<template>
  <div>
    <div class="flex items-end">
      <div class="mb-0 mr-2">
        <label class="text-secondary" v-html="bp('textStart')" />
        <date-picker
          class="mb-0"
          :allow-input="true"
          placeholder=""
          :enable-time="true"
          :no-calendar="true"
          date-format="h:i K"
          alt-format="h:i K"
          :name="startName"
          :value.sync="range.startTime"
          :minute-increment="30"
          @change="updateStartTime"
        />
      </div>

      <div class="mb-0">
        <label class="text-secondary" v-html="bp('textEnd')" />
        <date-picker
          class="mb-0"
          :allow-input="true"
          placeholder=""
          :enable-time="true"
          :no-calendar="true"
          date-format="h:i K"
          alt-format="h:i K"
          :name="endName"
          :value.sync="range.endTime"
          :minute-increment="30"
          @change="updateEndTime"
        />
      </div>

      <trek-button tertiary icon-only form-inline icon="delete" @click="$emit('update:remove', index)"> </trek-button>
    </div>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'StoreHourRange',

  components: {DatePicker, TrekButton},

  props: {
    baseProperties: {
      type: Array,
      default() {
        return [];
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    day: {
      type: Object,
      default: () => {},
    },
    range: {
      type: Object,
      default: () => ({
        startTime: '8:00 AM',
        endTime: '5:00 PM',
      }),
    },
  },
  data() {
    return {};
  },

  computed: {
    startName() {
      return `${this.day.name}-range-${this.range.id}-startTime`;
    },
    endName() {
      return `${this.day.name}-range-${this.range.id}-endTime`;
    },
  },

  methods: {
    updateStartTime(payload) {
      this.range.startTime = payload.event;
    },
    updateEndTime(payload) {
      this.range.endTime = payload.event;
    },
  },
};
</script>
